import clsx from 'clsx';
import React, { memo } from 'react';
import styles from '../CartButton/CartButton.module.scss';
import Button from '../../../../atoms/button';
import { useWishlistContext } from '@srcDS/provider/wishlist/WishlistContext';
import HeartEmpty from '@srcDS/components/atoms/icons/HeartEmpty';

interface WishlistButtonProps {
  isInvertedClass?: string;
  placement?: string;
  onClick?: () => void;
  isMobile?: boolean;
}

interface WishlistItem {
  count: number;
}


export const WishlistButton = memo<WishlistButtonProps>(({
  isInvertedClass,
  placement,
  onClick,
  isMobile,
}) => {
  const { wishlist } = useWishlistContext();

  const wishlistItemsCount = wishlist?.lineItems?.reduce(
    (acc: number, current: WishlistItem) => acc + current.count,
    0,
  );
  
  return (
    // @ts-ignore
    <Button
      variant="primary"
      as="text"
      onClick={onClick}
      ariaLabel="Wishlist"
      data-cart-icon={isMobile ? 'cart_icon_mob' : 'cart_icon_desk'}
      className={clsx(
        styles.button,
        placement && styles[`placement_${placement}`],
        isInvertedClass,
      )}
    >
      <HeartEmpty width="25px" height="25px" />
      {wishlistItemsCount ? (
        <span className={clsx(styles.cartCountText)} style={{ top: '-4px', right: '-3px' }}>
          {wishlistItemsCount}
        </span>
      ) : null}
    </Button>
  );
});